'use client';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const NavLink = styled(Link)`
  ${props => props.theme.typography.heading3};
  font-size: 2rem;
  color: inherit;
  background-color: transparent;
  margin: ${props => props.theme.spacing(0, 3)};
  outline: none;
  border: none;
  padding: 14px 2px 2px 2px;
  margin-bottom: 2px !important;
  display: inline;

  &:focus,
  &:hover {
    text-decoration: none;
    padding-bottom: 0;
    color: ${props => props.theme.colors.secondary.lilac};
  }

  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.body};
    color: inherit;
    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

export const SmallNavLink = styled(NavLink)`
  display: ${props => (props.showLink ? 'inline' : 'none')};
  ${props => props.theme.typography.body};
  &:focus {
    outline: 0;
  }
  @media ${props => props.theme.mobileL} {
    display: inline;
  }
`;

export const Header = styled.header`
  display: block;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  ${props =>
    props.$sticky &&
    css`
      position: sticky;
      top: ${props => (!props.$stickyBanner && props.$hasBanner ? -40 : 0)}px;
      z-index: 100;
    `};
  ${props =>
    props.$cro &&
    css`
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
    `}
  ${props =>
    props.$centerLogo &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
  ${props =>
    props.$dropshadow &&
    css`
      min-height: 76px;
      width: 100%;
      filter: drop-shadow(0 1px 8px rgba(0, 0, 0, 0.05));
    `}
`;

export const StyledLoginButton = styled.button`
  display: ${props => (props.showButton ? 'inline' : 'none')};
  ${props => props.theme.typography.body};
  outline: none;
  border: none;
  color: inherit;
  padding: 14px 2px 2px 2px;
  &:focus,
  &:hover {
    text-decoration: none;
    padding-bottom: 0;
    border-bottom: 2px solid ${props => props.theme.colors.border.dark};
  }
  background: transparent;

  @media ${props => props.theme.mobileL} {
    display: inline;
    margin: 0 12px 2px;
  }
`;

export const StyledHeaderButton = styled.button`
  ${props => props.theme.typography.heading3};
  background: transparent;
  display: inline;
  margin: ${props => props.theme.spacing(0, 3)};
  outline: none;
  padding: 13px 2px 2px 2px;
  color: inherit;
  border: none;
  &:focus,
  &:hover {
    text-decoration: none;
    padding-bottom: 0;
    border-bottom: 2px solid ${props => props.theme.colors.secondary.lilac};
  }
  margin-bottom: 2px !important;
  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.body};
  }
`;

// this handles the Profile Icon color change
export const StyledProfileWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(3)};
  svg {
    vertical-align: bottom;
  }
  &:hover {
    svg {
      fill: none;
      stroke: ${({ theme }) => theme.colors.secondary.lilac};
    }

    ${SmallNavLink} {
      color: ${({ theme }) => theme.colors.secondary.lilac};
      text-decoration: underline;
      text-underline-offset: ${props => props.theme.spacing(2)};
    }
  }
`;
